import { createAsyncThunk } from '@reduxjs/toolkit';
import * as messageTemplateApi from '../../api/messagetemplateapi';

export const getMessageTemplate = createAsyncThunk('getMessageTemplate', async (data) => {
    const res = await messageTemplateApi.getMessageTemplate({ data: data });
    return res.data;
});

export const addEditMessageTemplate = createAsyncThunk('addEditMessageTemplate', async (data) => {
    const res = await messageTemplateApi.addEditMessageTemplate({ data: data });
    return res.data;
});


export const deleteTemplate = createAsyncThunk('deleteTemplate', async (data) => {
    const res = await messageTemplateApi.deleteTemplate({ data: data });
    return res.data;
});
